import { Controller } from "@hotwired/stimulus";

// 刺さってるフォームをロード時に自動送信する
// <form data-controller="beacon">
export default class extends Controller {
  connect() {
    // turbo preview では発火させない
    if (document.documentElement.hasAttribute("data-turbo-preview")) return;

    this.#submit();
  }

  #submit() {
    // turbo でないと初回（新タブ）ServiceWorkerが空のファイルを
    // ダウンロードしようとして失敗する (204 No Contentの場合)
    // 200, 201 などで返すと画面遷移してしまう
    this.element.dataset.turbo = true;
    // 次の描画フレームで非同期実行
    window.requestAnimationFrame(() => {
      this.element.requestSubmit();
    });
  }
}
